import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type UpdateRequestFunction = (fieldValue: string) => Observable<any>;

@Component({
  selector: 'rnpl-remark-modal',
  templateUrl: './remark-modal.component.html',
})
export class RemarkModalComponent implements OnDestroy {

  readonly destroy$: Subject<void> = new Subject();

  constructor(
    public dialogRef: MatDialogRef<RemarkModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      remark: string;
      updateRequest$: UpdateRequestFunction;
    }
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  public submit(value): void {
    this.data.updateRequest$(value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.dialogRef.close();
      }); // updated via store
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
